import { register } from '@shopify/theme-sections';

export default register('collection-page', {
  onLoad() {},
});
